import { FormInputSelect } from 'camino-react'
import React from 'react'
import { find } from 'lodash'

const Type = ({ editedItem, ticketTypes }) => {
  const ticketTypeOptions = ticketTypes.map(({ id: value, name: label }) => (
    { label, value }
  ))

  const currentTicketType = () => (
    find(ticketTypeOptions, ({ value: editedItem.ticketType }))
  )

  const handleTicketType = (type) => (
    editedItem.updateOptionValue('ticketType', type)
  )

  return (
    <FormInputSelect
      placeholder="Ticket Type"
      value={currentTicketType()}
      options={ticketTypeOptions}
      onValue={value => handleTicketType(value)}
      clearable
    />
  )
}

export default Type
